var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "download_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 289.6 289.6"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".download_svg__st0{fill:#172b4d}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_svg__Group_350"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#172B4D",
    d: "M285.4 178.1c-2.7-2.8-6.4-4.3-10.3-4.3-8 0-14.5 6.5-14.5 14.5v57.9c0 8-6.5 14.5-14.5 14.5H43.5c-8 0-14.5-6.5-14.5-14.5v-57.9c0-8-6.5-14.5-14.5-14.5S0 180.3 0 188.3v57.9c0 11.6 4.5 22.5 12.7 30.7s19.1 12.7 30.7 12.7h202.7c11.6 0 22.5-4.5 30.7-12.7s12.7-19.1 12.7-30.7v-57.9c.1-3.9-1.4-7.5-4.1-10.2",
    className: "download_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172B4D",
    d: "M228.3 105.6c-2.6-2.9-6.2-4.5-10.1-4.7h-.6c-3.7 0-7.2 1.4-9.9 3.9l-.4.4-.4.3-47.6 47.6V14.5c0-8-6.5-14.5-14.5-14.5s-14.5 6.5-14.5 14.5v138.7l-47.5-47.6c-2.7-2.8-6.3-4.3-10.2-4.4s-7.5 1.3-10.4 4c-2.8 2.7-4.3 6.3-4.4 10.2s1.3 7.5 4 10.4l.3.4 72.5 72.4c2.8 2.7 6.4 4.2 10.3 4.2s7.5-1.5 10.3-4.2l72.4-72.4c2.9-2.6 4.5-6.2 4.7-10.1 0-3.9-1.3-7.7-4-10.5",
    className: "download_svg__st0"
  }))));
};
export default SvgDownload;